<template>
  <div class="param-edit">
    <base-headline title="基本信息" class="headline no-top" />
    <el-form class="zwx-form edit-form" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules"
             label-position="right">
      <!-- 基础信息部分 -->
      <div class="edit-row">
        <el-form-item label-width="82px" label="参数名称：" prop="parameterKey">
          <el-input class="zwx-input" v-model="mainForm.parameterKey" maxlength="50" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="参数类型：" prop="parameterType">
          <el-select class="zwx-select" v-model="mainForm.parameterType" :clearable="true"
                     @change="parameterTypeChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="82px" label="参数值：" prop="parameterValue" v-if="mainForm.parameterType==1">
          <el-input class="zwx-input" v-model="mainForm.parameterValue" maxlength="500" placeholder="请输入"
                    clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="参数值：" prop="parameterValue" v-if="mainForm.parameterType==2">
          <el-radio-group class="zwx-radio-group" v-model="mainForm.parameterValue" @change="parameterValueChange">
            <el-radio class="zwx-radio" :label="'1'">是</el-radio>
            <el-radio class="zwx-radio" :label="'0'">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="82px" label="图片上传：" prop="annexList" v-if="mainForm.parameterType==3">
          <file-upload ref="picFileRef" accept=".png,.jpeg,.jpg,.JPG,.JPEG,.PNG," @showFileList="picFileShowFileList"
                       @success="picFileUploadSuccess" :size="50 * 1024 * 1024" sizeInfo="50M">
            <el-button class="zwx-button zwx-button-text-26" icon="el-icon-upload2"
                       v-if="$zwxBase.verifyIsBlank(mainForm.annexList)">上传
            </el-button>
          </file-upload>
          <div class="show-file" v-if="$zwxBase.verifyIsNotBlank(mainForm.annexList)">
            <el-button class="zwx-button zwx-button-text-26" @click="openFilePreview(mainForm.annexList, 0)">查看
            </el-button>
            <el-button class="zwx-button zwx-button-text-26" type="danger" @click="deletionPicFile(0)">删除</el-button>
          </div>
        </el-form-item>
      </div>
      <div class="edit-row">
        <el-form-item label-width="82px" label="参数描述：" prop="parameterDescription">
          <el-input class="zwx-input" v-model="mainForm.parameterDescription" maxlength="100" placeholder="请输入"
                    clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <fixed-footer>
      <el-button class="zwx-button zwx-button-28" type="primary"
                 @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交
      </el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </fixed-footer>
  </div>
</template>

<script>
export default {
  name: "ParamEdit",
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      mainForm: {
        parameterKey: "",
        parameterType: 1,
        parameterValue: "",
        parameterDescription: "",
        ifEnable: true,
        annexList: []
      },
      rules: {
        parameterKey: [{ required: true, message: "请输入参数名称", trigger: ["change", "blur"] }],
        parameterType: [{ required: true, message: "请选择参数类型", trigger: ["change", "blur"] }],
        parameterValue: [{ required: true, message: "请输入参数值", trigger: ["change", "blur"] }],
        parameterDescription: [{ required: true, message: "请输入参数描述", trigger: ["change", "blur"] }],
        annexList: [{ required: true, message: "请上传图片", trigger: ["change", "blur"] }]
      },
      options: [
        {
          value: 1,
          label: "文本"
        },
        {
          value: 2,
          label: "布尔"
        },
        {
          value: 3,
          label: "图片"
        }
      ],
      folder: "/onlineTraining" //文件存储路径
    };
  },
  created() {
  },
  mounted() {
    this.detail();
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs;
    }
  },
  methods: {
    // 参数类型change事件
    parameterTypeChange(val) {
      this.mainForm.parameterValue = "";
      this.mainForm.parameterDescription = "";
      this.mainForm.annexList = [];
      this.$nextTick(() => {
        this.$refs.mainForm.clearValidate();
      });
    },
    // 参数值change事件
    parameterValueChange(val) {
      //this.mainForm.parameterDescription = val
    },
    detail() {
      if (this.rid === undefined) return;
      this.$emit("loading", true);
      let data = {
        rid: this.rid
      };
      this.$system.get(this.api + "/systematic/getParameter-1", data, true, true, this.detailSuccess, this.detailError);
    },
    detailSuccess(data) {
      if (data.type === "00") {
        this.mainForm.parameterKey = data.parameter.parameterKey;
        this.mainForm.parameterType = data.parameter.parameterType;
        this.mainForm.parameterValue = data.parameter.parameterValue;
        this.mainForm.parameterDescription = data.parameter.parameterDescription;
        this.mainForm.ifEnable = data.parameter.ifEnable;
        this.mainForm.annexList = [];
        if (this.mainForm.parameterType == 3 && this.$zwxBase.verifyIsNotBlank(this.mainForm.parameterValue)) {
          this.mainForm.annexList.push({
            fileIconShow: "ms-file-jpg-icon",
            check: false,
            filePath: this.mainForm.parameterValue
          });
        }
        this.$emit("loading", false);
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
        this.back();
      }
    },
    detailError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
      this.back();
    },
    commit() {
      this.$emit("loading", true);
      let data = {
        rid: this.rid,
        parameterKey: this.mainForm.parameterKey,
        parameterType: this.mainForm.parameterType,
        parameterValue: this.mainForm.parameterValue,
        parameterDescription: this.mainForm.parameterDescription,
        ifEnable: this.mainForm.ifEnable
      };
      this.$system.postJson(this.api + "/systematic/addOrModifyParameter-1", data, true, true, this.commitSuccess, this.commitError);
    },
    commitSuccess(data) {
      if (data.type === "00") {
        this.$system.notify("成功", data.mess, "success");
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } });
      } else if (data.type === "99") {
        this.$router.push({ name: "ErrorPage", params: { mess: data.mess } });
      } else {
        this.$system.notify("错误", data.mess, "error");
        this.$emit("loading", false);
      }
    },
    commitError() {
      this.$system.notify("错误", "网络连接失败", "error");
      this.$emit("loading", false);
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name });
    },

    // 获取上传图片文件的UID
    generateFilesUidPic() {
      this.$emit("loading", true);
      let data = {
        folder: this.folder
      };
      this.$system.get(
        this.api + "/systematic/tools/getAnnexUploadUid-1",
        data,
        true,
        true,
        data => {
          if (data.type === "00") {
            this.$refs.picFileRef.submit(data.annexUploadUid);
            this.$emit("loading", false);
          } else {
            this.$emit("loading", false);
            this.$system.notify("错误", data.mess, "error");
          }
        },
        {}
      );
    },
    /**
     * 图片文件上传成功回调
     */
    picFileUploadSuccess(fileList) {
      // 文件集合
      if (this.$zwxBase.verifyIsNotBlank(this.mainForm.annexList) && this.$zwxBase.verifyIsNotBlank(fileList)) {
        for (let i in this.mainForm.annexList) {
          for (let j in fileList) {
            if (this.mainForm.annexList[i].fileName === fileList[j].fileName) {
              this.mainForm.annexList[i].filePath = fileList[j].filePath;
            }
          }
        }
        this.mainForm.parameterValue = this.mainForm.annexList.length > 0 ? this.mainForm.annexList[0].filePath : "";
      }
    },
    /**
     * 文件上传失败回调
     */
    picFileUploadSuccessError() {
      this.$system.notify("失败", "文件上传失败", "error");
    },
    /**
     * 图片文件上传显示回调
     */
    picFileShowFileList(showList) {
      showList.forEach(item => {
        let flag = this.mainForm.annexList.some(e => e.fileName == item);
        if (flag) {
          return;
        }
        this.mainForm.annexList.push({
          fileName: item,
          fileIconShow: this.$zwxBase.dealfilePrefix(item),
          check: false
        });
      });
      if (showList && showList.length > 0) {
        this.generateFilesUidPic();
      }
    },
    /**
     * 删除题目图片文件
     */
    deletionPicFile(index) {
      let fileName = this.mainForm.annexList[index].fileName;
      let filePath = this.mainForm.annexList[index].filePath;
      this.mainForm.annexList.splice(index, 1);
      if (this.$zwxBase.verifyIsBlank(filePath)) {
        this.$refs.picFileRef.deleteIndex(index);
      }
      let fileList = this.$refs.picFileRef.showFileList || [];
      let count = 0;
      fileList.forEach(item => {
        if (fileName === item) {
          count++;
        }
      });
      for (let i = 0; i < count; i++) {
        for (let j in fileList) {
          if (fileName === fileList[j]) {
            this.$refs.picFileRef.deleteIndex(j);
            fileList = this.$refs.picFileRef.showFileList || [];
            continue;
          }
        }
      }
    },
    /**
     * 多个文件预览
     */
    openFilePreview(fileList, index) {
      top.postMessage(
        {
          handlerType: "previewFile",
          params: {
            fileList: fileList,
            index: index
          }
        },
        "*"
      );
    }
  }
};
</script>
